export default __webpack_public_path__ + "static/Plots0008-bbb0b707fa06605aa470161c24a4e456.jpg";